// extracted by mini-css-extract-plugin
export default {"carousel":"pE-z"};